import { TimelineTimeframe } from '@wilson/interfaces';
import { Interval } from 'date-fns';

export function dateToPositionPx(
  date: Date,
  {
    fromRightSide,
    interval,
    timelineWidthPixel,
  }: {
    fromRightSide?: boolean;
    timelineWidthPixel: number;
    interval: Interval | TimelineTimeframe;
  },
): number {
  const intervalStartDate = new Date(interval.start);
  const intervalEndDate = new Date(interval.end);

  const intervalStartMs =
    intervalStartDate.getTime() -
    intervalStartDate.getTimezoneOffset() * 60 * 1000;
  const intervalEndMs =
    intervalEndDate.getTime() - intervalEndDate.getTimezoneOffset() * 60 * 1000;
  const dateMs = date.getTime() - date.getTimezoneOffset() * 60 * 1000;

  const intervalDuration = intervalEndMs - intervalStartMs;
  const positionDuration = dateMs - intervalStartMs;

  const positionPx = (timelineWidthPixel / intervalDuration) * positionDuration;

  if (fromRightSide) {
    return timelineWidthPixel - positionPx;
  } else {
    return positionPx;
  }
}
